var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block text-black text-center",style:(_vm.grayscaleStyle),attrs:{"title":_vm.integration.name}},[(_vm.integration.icon_url)?_c('img',{staticStyle:{"height":"1.25rem"},attrs:{"src":_vm.integration.icon_url,"alt":_vm.integration.code}}):_c('i',{class:_vm.integration?.icon || 'fas fa-question-circle'})])
}
var staticRenderFns = []

export { render, staticRenderFns }